import React from "react";
// limitless imports
import { MessageClassificationForm } from "../../../../../expert";
import ConversationPanelFooter from "../conversation-panel-footer/ConversationPanelFooter";
const ConversationRespondPanelFooter = () => {
  return /*#__PURE__*/React.createElement(MessageClassificationForm, null, ({
    isCancelDisabled,
    onFormSubmit,
    isFinishDisabled,
    hasExpertTouchedMessage
  }) => {
    return /*#__PURE__*/React.createElement(ConversationPanelFooter, {
      onFinish: onFormSubmit,
      isCancelDisabled: isCancelDisabled,
      isFinishDisabled: isFinishDisabled,
      finishTooltip: hasExpertTouchedMessage ? "You must complete classification before this conversation can be finished" : "You must reply before this conversation can be finished",
      cancelTooltip: "You cannot cancel, you must finish the conversation after you have replied"
    });
  });
};
export default ConversationRespondPanelFooter;